<template>
  <div id="data-list-list-view" class="data-list-container">
    <div class="w-full flex justify-end mt-2">
      <SelectPagination
        v-if="itens.length > 0"
        :currentPage="pagination.page"
        :itemsPerPage="pagination.itemsPerPage"
        :length="totalCount"
        @update="updateSelectPagination"
      />
    </div>

    <vs-table
      v-if="tableKey !== null"
      :key="tableKey"
      noDataText="Nenhum registro encontrado"
      ref="table"
      :data="itens"
      :max-items="pagination.itemsPerPage"
    >
      <template slot="thead">
        <vs-th style="width: 20%" class="table-head">Corretora</vs-th>
        <vs-th style="width: 15%" class="table-head">CPF/CNPJ</vs-th>
        <vs-th style="width: 10%" class="table-head">Data de Envio</vs-th>
        <vs-th style="width: 5%" class="table-head">Portal</vs-th>
        <vs-th style="width: 20%" class="table-head">Assessoria</vs-th>
        <vs-th style="width: 10%" class="table-head">Status</vs-th>
        <vs-th style="width: 10%" class="table-head">Data da Análise</vs-th>
        <vs-th style="width: 10%" class="table-head">Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.socialName }}</vs-td>
            <vs-td>{{ tr.cpfCnpj }}</vs-td>
            <vs-td>
              {{
                functions.formatDateAndHour(
                  tr.receivedAt ? tr.receivedAt : tr.createdAt,
                )
              }}
            </vs-td>
            <vs-td>{{ tr.portal }}</vs-td>
            <vs-td>{{ tr.consultancyName }}</vs-td>
            <vs-td>
              <vs-chip :color="getStatusColor(tr.registerStatus)">
                <span class="text-center">
                  {{ tr.registerStatus }}
                </span>
              </vs-chip>
            </vs-td>
            <vs-td>
              {{ functions.formatDateAndHour(tr.analysisDate) }}
            </vs-td>
            <vs-td>
              <div class="flex gap-2">
                <vs-button
                  v-if="haveReadPermission"
                  v-tooltip="'Analisar Cadastro'"
                  radius
                  color="primary"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="edit(tr.id)"
                />
                <vs-button
                  radius
                  v-tooltip="'Histórico de Alterações'"
                  color="#88abc2"
                  icon-pack="feather"
                  icon="icon-archive"
                  class="d-inline"
                  @click="logs(tr.id)"
                />
                <vs-button
                  v-if="isManualRegistration(tr.registerStatus)"
                  radius
                  v-tooltip="getTooltipTextConfirm(tr.registerStatus)"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-thumbs-up"
                  class="d-inline"
                  @click="manualApprove(tr.id)"
                />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination
      :key="`pagination-${pagination.page}`"
      :max="viewportW < 650 ? 5 : 9"
      :total="Math.ceil(totalCount / pagination.itemsPerPage)"
      :value="pagination.page"
      @input="updateSelectedPage"
    />
  </div>
</template>

<script>
import functions from '../../../../../utils/functions';
import SelectPagination from '../../../../../utils/list/header/SelectPagination.vue';
import {
  BROKER_PRE_REGISTER_LABELS_COLOR_BY_STATUS,
  BROKER_PRE_REGISTER_STATUS,
} from '../constants/broker.pre.register';

export default {
  name: 'BrokerPreRegisterDataList',
  components: { SelectPagination },
  props: {
    itens: { type: Array, required: true },
    pagination: {
      itemsPerPage: { type: Number, required: true },
      page: { type: Number, required: true },
      required: true,
    },
    totalCount: { type: Number, required: true },
  },
  data() {
    return {
      functions,
      tableKey: 0,
      viewportW: window.innerWidth,
    };
  },
  computed: {
    haveReadPermission() {
      return this.$can('Escrita', 'Pré-Cadastro Corretoras');
    },
  },
  watch: {
    itens: {
      handler: function () {
        this.tableKey++;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize: function () {
      this.viewportW = window.innerWidth;
    },
    isManualRegistration: function (status) {
      return (
        status === BROKER_PRE_REGISTER_STATUS.MANUAL_REGISTRATION ||
        status === BROKER_PRE_REGISTER_STATUS.EXTERNAL_REGISTRATION
      );
    },
    edit: function (id) {
      this.$router.push('/pre-cadastro-corretoras/' + id);
    },
    logs: function (id) {
      this.$emit('logs', id);
    },
    getStatusColor: function (status) {
      return BROKER_PRE_REGISTER_LABELS_COLOR_BY_STATUS[status];
    },
    getTooltipTextConfirm: function (status) {
      return status === BROKER_PRE_REGISTER_STATUS.EXTERNAL_REGISTRATION
        ? 'Confirmar Cadastro Externo'
        : 'Confirmar Cadastro Manual';
    },
    manualApprove: function (id) {
      this.$emit('manualApprove', id);
    },
    updateSelectPagination: function (value) {
      this.$emit('update:pagination', { itemsPerPage: value, page: 1 });
    },
    updateSelectedPage: function (value) {
      this.$emit('update:pagination', {
        itemsPerPage: this.pagination.itemsPerPage,
        page: value,
      });
    },
  },
};
</script>

<style lang="scss">
@import './../../../../../utils/list/style-table';

.table-head {
  width: 16%;
}

.table-content-center {
  .vs-table-text {
    display: block;
    text-align: center;
  }
}

#data-list-list-view {
  @include style-table;
}
</style>
